import React, { useContext, useEffect, useState } from "react";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOwDivTableCols from "../../../shared/OwDivTable/IOwDivTableCols";
import IOnGetInventoryStockLevelsReportDTO from "../../../../models/DTO/IOnGetInventoryStockLevelsReportDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { OwDivTable } from "../../../shared/OwDivTable/OwDivTable";
import SupplierService from "../../../../services/SupplierService";
import UserService from "../../../../services/UserService";
import ExcelJS from 'exceljs/dist/exceljs.min.js';

type Props = {
    processedReport: IProcessed_Report;
};

export const InventoryStockLevelsReport = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const getTableCols = (): IOwDivTableCols[] => {
        return [
            {
                title: "name",
                renderFn: (item) => item.name,
                className: "w-20",
            },
            {
                title: "sku",
                renderFn: (item) => item.sku,
                className: "w-20",
            },
            {
                title: "qty_on_hand",
                renderFn: (item) => item.qty_on_hand,
                className: "w-20",
            },
            {
                title: "reserved_qty_on_hand",
                renderFn: (item) => item.reserved_qty_on_hand,
                className: "w-20",
            },
            {
                title: "qty_incoming",
                renderFn: (item) => item.qty_incoming,
                className: "w-20",
            },
        ];
    };

    const [reportData, setReportData] = useState<IOnGetInventoryStockLevelsReportDTO>();
    const [tableCols, setTableCols] = useState<IOwDivTableCols[]>(getTableCols());

    const onGetInventoryStockLevelsReport = (data: IOnGetInventoryStockLevelsReportDTO) => {
        console.log("onGetInventoryStockLevelsReport: ", data);
        setReportData(data);
    };

    useEffect(() => {
        onGetInventoryStockLevelsReport(props.processedReport.report_data);
    }, []);

    const downloadExcel = () => {
        if (reportData) {
            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet(`Inventory Stock Levels`);

            const salesPeopleWs: { salesperson: string; ws: ExcelJS.Worksheet }[] = [];

            const columns: (
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
            )[] = [
                { header: "Name", key: "name" },
                { header: "SKU", key: "sku" },
                { header: "Qty. On Hand", key: "qtyOnHand" },
                { header: "Reserved Qty. On Hand", key: "reservedQtyOnHand" },
                { header: "Qty. Incoming", key: "qtyIncoming" },
            ];

            ws.columns = columns;

            ws.getCell("A1").font = {
                bold: true,
            };

            ws.getCell("B1").font = {
                bold: true,
            };

            ws.getCell("C1").font = {
                bold: true,
            };

            ws.getCell("D1").font = {
                bold: true,
            };

            ws.getCell("E1").font = {
                bold: true,
            };

            for (const item of reportData.data) {
                const name = item.name;
                const sku = item.sku;
                const qtyOnHand = item.qty_on_hand;
                const reservedQtyOnHand = item.reserved_qty_on_hand;
                const qtyIncoming = item.qty_incoming;

                ws.addRow({ name, sku, qtyOnHand, reservedQtyOnHand, qtyIncoming });
            }

            // const periodStart = moment(reportData.periodStart).format("YYYY-MM-DD");
            // const periodEnd = moment(reportData.periodEnd).format("YYYY-MM-DD");

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `orderwerks-inventory-stock-levels-${UserService.parseLastUpdated(
                    props.processedReport.created_at
                )}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        }
    };

    return (
        <div className={"InventoryStockLevelsReport"}>
            {reportData && reportData.data.length > 0 ? <OwButton title={"export_to_excel"} fn={downloadExcel} /> : null}
            <div>
                <OwLabel title={"total_records"} postText={":"} isBold={true} className={"me-2 mb-2 mt-2"} />
                {reportData?.data.length}
                <div>
                    <OwLabel title={"created_at"} className={"me-2"} postText={":"} />
                    {UserService.parseLastUpdated(props.processedReport.created_at)}
                </div>
            </div>

            <div className={"mb-5"}>
                <OwDivTable cols={tableCols} data={reportData?.data || []} rowClassName={"border-bottom"} />
            </div>
        </div>
    );
};
